// extracted by mini-css-extract-plugin
export default {"legend":"Legend__legend___ZV9QX","item":"Legend__item___up_Is","label":"Legend__label___rMQE9 fonts__whitney-book___cSNvy","smallCell":"Legend__smallCell___sgT85"};